;(function() {
  'use strict'

  Controller.$inject = ["$scope", "$state", "elementsService"];
  angular.module('app.element').controller('ElementCreate', Controller)

  /* @ngInject */
  function Controller($scope, $state, elementsService) {
    var fieldsForType = {
      place: ['type', 'title', 'address', 'city', 'state'],
      product: ['type', 'brand', 'name', 'code'],
      other: ['type', 'title', 'subTitle'],
    }

    $scope.friendlyTypes = {
      place: 'Place',
      product: 'Product',
      other: 'Other',
    }

    $scope.states = [
      { value: 'NSW', label: 'New South Wales' },
      { value: 'VIC', label: 'Victoria' },
      { value: 'QLD', label: 'Queensland' },
      { value: 'WA', label: 'Western Australia' },
      { value: 'SA', label: 'South Australia' },
      { value: 'NT', label: 'Northern Territory' },
      { value: 'TAS', label: 'Tasmania' },
      { value: 'ACT', label: 'Australian Capital Territory' },
    ]

    $scope.data = {}
    $scope.element = {}
    $scope.isValid = isValid
    $scope.create = create

    function isValid() {
      var valid = true
      var elem = $scope.element

      if (elem.type === 'product') {
        if (!elem.name) {
          err('Please enter a product name')
        } else if (!elem.brand) {
          err('Please enter a brand')
        }
      }
      if (elem.type === 'place') {
        if (!elem.title) {
          err('Please enter a name')
        } else if (!elem.address) {
          err('Please enter an address')
        } else if (!elem.city) {
          err('Please enter a city')
        } else if (!elem.state) {
          err('Please select a state')
        }
      }
      if (elem.type === 'other') {
        if (!elem.title) {
          err('Please enter a name')
        } else if (!elem.subTitle) {
          err('Please enter a description')
        }
      }

      function err() {
        valid = false
      }

      return valid
    }

    function create() {
      $scope.data.error = null
      var data = _.pick($scope.element, fieldsForType[$scope.element.type])
      $scope.data.saving = true
      elementsService.create(data).then(
        function(data) {
          $scope.data.saving = false
          $scope.dialog.close()
          $state.go('app.portal.element', { id: data.id })
        },
        function() {
          $scope.data.saving = false
          $scope.data.error =
            'Something went wrong. Please check your details and try again'
        }
      )
    }
  }
})()
